import React, { useEffect, useRef } from 'react';
import { Badge } from '../ui/badge';
import './TaskConversationViewer.css';

const TaskConversationViewer = ({ conversation, taskTitle, taskDescription, userName, workPlanDate, taskStatusAtTime, project }) => {
  const messagesEndRef = useRef(null);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [conversation]);

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { 
      month: 'short', 
      day: 'numeric',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const formatTime = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleTimeString('en-US', { 
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  if (!conversation || !Array.isArray(conversation) || conversation.length === 0) {
    return (
      <div className="task-conversation-viewer-empty">
        <p>No conversation history available for this task.</p>
      </div>
    );
  }

  return (
    <div className="task-conversation-viewer">
      {/* Header with task and user info */}
      <div className="task-conversation-viewer-header">
        <div className="task-conversation-viewer-header-content">
          <div className="task-conversation-viewer-title-section">
            <h3 className="task-conversation-viewer-title">{taskTitle || 'Task Conversation'}</h3>
            {project && (
              <span className="task-conversation-viewer-project">
                {project.abbreviation || project.name}
              </span>
            )}
          </div>
          <div className="task-conversation-viewer-meta">
            {userName && (
              <div className="task-conversation-viewer-meta-item">
                <span className="task-conversation-viewer-meta-label">User:</span>
                <span className="task-conversation-viewer-meta-value">{userName}</span>
              </div>
            )}
            {workPlanDate && (
              <div className="task-conversation-viewer-meta-item">
                <span className="task-conversation-viewer-meta-label">Date:</span>
                <span className="task-conversation-viewer-meta-value">
                  {new Date(workPlanDate).toLocaleDateString('en-US', { 
                    month: 'short', 
                    day: 'numeric',
                    year: 'numeric'
                  })}
                </span>
              </div>
            )}
            {taskStatusAtTime && (
              <div className="task-conversation-viewer-meta-item">
                <span className="task-conversation-viewer-meta-label">Status:</span>
                <Badge variant={
                  taskStatusAtTime === 'completed' || taskStatusAtTime === 'released' ? 'success' :
                  taskStatusAtTime === 'in-progress' ? 'warning' : 'secondary'
                }>
                  {taskStatusAtTime}
                </Badge>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Task Description (if available) */}
      {/* {taskDescription && (
        <div className="task-conversation-viewer-description">
          <p>{taskDescription}</p>
        </div>
      )} */}

      {/* Messages */}
      <div className="task-conversation-viewer-messages">
        {conversation.map((message, index) => {
          const isBot = message.role === 'bot' || message.role === 'assistant';
          const isUser = message.role === 'user';
          
          if (!isBot && !isUser) return null;

          return (
            <div
              key={index}
              className={`task-conversation-viewer-message ${isBot ? 'bot' : 'user'}`}
            >
              <div className="task-conversation-viewer-message-content">
                {message.content}
              </div>
              {message.timestamp && (
                <div className="task-conversation-viewer-message-time">
                  {formatTime(message.timestamp)}
                </div>
              )}
            </div>
          );
        })}
        <div ref={messagesEndRef} />
      </div>
    </div>
  );
};

export default TaskConversationViewer;

